if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name="id"]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items');
      this.useSuccessMessage = this.cart && this.cart.tagName.toLowerCase() !== 'cart-notification';
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.addonBlocks = null;
      this.pendingAddonItems = [];
      this.formId = this.form?.getAttribute('id') || '';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      this.pendingAddonItems = this.collectAddonItems();
      const request = this.prepareRequestConfig();
      const formData = request.formData;

      fetch(`${routes.cart_add_url}`, request.config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status && response.status != 422) {
            document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message
            }}));
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if(!this.error) {
            if(response.status != 422) {
              this.error = false;
              if(this.useSuccessMessage) {
                pushSuccessMessage(window.cartStrings.success);
              }
              return this.handleAddonWorkflow(response, formData.get('id'));
            } else {
              this.handleErrorMessage(response.description);
              this.handle422Error(formData.get('id'));
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    prepareRequestConfig(setZeroQuantity = false) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      if(setZeroQuantity) {
        formData.set('quantity', 0);
      }

      return {
        config: config,
        formData: formData
      };
    }

    handle422Error(variantId) {
      const request = this.prepareRequestConfig(true);
     
      fetch(`${routes.cart_add_url}`, request.config)
        .then((response) => response.json())
        .then(response => {
          this.completeAddToCartAction(response, variantId);
        });
    }

    completeAddToCartAction(response, variantId) {
      const quickAddDrawer = this.closest('quick-add-drawer');
      if (quickAddDrawer) {
        document.body.addEventListener('drawerClosed', () => {
          setTimeout(() => { this.cart.renderContents(response) });
        }, { once: true });
        quickAddDrawer.close();
      } else {
        this.cart.renderContents(response);
      }
      document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {
        productVariantId: variantId,
        source: 'product-form',
        cartData: response
      }}));
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text && this.submitButtonText) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        if(this.submitButtonText) {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if(errorMessage && !this.errorMessageWrapper) {
        pushErrorMessage(errorMessage);
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    collectAddonItems() {
      if (this.addonBlocks === null) {
        const formIdString = this.formId || (this.form?.id ? String(this.form.id) : '');
        const selector = `[data-product-addons][data-form-id="${formIdString}"]`;
        console.log('[Product Form] Looking for addon blocks with selector:', selector);
        console.log('[Product Form] Form ID:', formIdString);
        this.addonBlocks = Array.from(document.querySelectorAll(selector));
        console.log('[Product Form] Found addon blocks:', this.addonBlocks.length);
        
        // Debug: Check all addon blocks on page
        const allAddonBlocks = Array.from(document.querySelectorAll('[data-product-addons]'));
        console.log('[Product Form] All addon blocks on page:', allAddonBlocks.length);
        allAddonBlocks.forEach((block, index) => {
          console.log(`[Product Form] Addon block ${index}:`, {
            formId: block.dataset.formId,
            matches: block.dataset.formId === formIdString
          });
        });
      }
      if (!this.addonBlocks.length) {
        console.log('[Product Form] No addon blocks found for form:', this.formId);
        return [];
      }

      const addonItems = [];
      this.addonBlocks.forEach((block) => {
        const groupLabel = block.dataset.addonHeading;
        const parentTitle = block.dataset.parentTitle;
        const maxQty = parseInt(block.dataset.maxQty || '10', 10);
        const defaultQty = parseInt(block.dataset.defaultQty || '1', 10);

        block.querySelectorAll('[data-addon-item]').forEach((item) => {
          const variantInput = item.querySelector('[data-addon-variant-select]');
          const quantityInput = item.querySelector('[data-addon-quantity]');
          
          // Get quantity - if quantity is 0 or less, skip this item
          const quantityValue = parseInt(quantityInput?.value || '0', 10);
          if (quantityValue <= 0) {
            console.log('[Product Form] Addon item skipped - quantity is 0:', item.dataset.addonProductTitle);
            return;
          }

          // Get variant ID: priority 1) selected variant from data attribute, 2) variant select value, 3) default variant
          const variantId = item.dataset.selectedVariant || (variantInput ? variantInput.value : null) || item.dataset.defaultVariant;
          if (!variantId) {
            console.log('[Product Form] Addon item skipped - no variant ID:', item.dataset.addonProductTitle);
            return;
          }

          const productTitle = item.dataset.addonProductTitle;
          const quantity = Math.max(1, Math.min(quantityValue, maxQty));

          console.log('[Product Form] Adding addon item:', { id: variantId, quantity, productTitle });
          addonItems.push({
            id: variantId,
            quantity,
            properties: null
          });
        });
      });

      console.log('[Product Form] Total addon items collected:', addonItems.length);
      return addonItems;
    }

    handleAddonWorkflow(initialResponse, variantId) {
      const addonItems = Array.isArray(this.pendingAddonItems) ? this.pendingAddonItems.slice() : [];
      this.pendingAddonItems = [];
      this.completeAddToCartAction(initialResponse, variantId);

      if (!addonItems.length || !this.cart) {
        return Promise.resolve(initialResponse);
      }

      const sections = this.cart.getSectionsToRender().map((section) => section.id);
      const sectionPayload = sections.length
        ? { sections, sections_url: window.location.pathname }
        : {};

      return this.addAddonItemsSequentially(addonItems, sectionPayload).catch((error) => {
        const message = error?.message || window.cartStrings.error;
        this.handleErrorMessage(message);
        if (typeof pushErrorMessage === 'function') {
          pushErrorMessage(message);
        }
        throw error;
      });
    }

    addAddonItemsSequentially(addonItems, sectionPayload = {}) {
      const queue = addonItems.slice();
      const processNext = () => {
        if (!queue.length) return Promise.resolve();
        const addon = queue.shift();
        return this.addAddonItem(addon, sectionPayload).then((response) => {
          this.completeAddToCartAction(response, addon.id);
          return processNext();
        });
      };
      return processNext();
    }

    addAddonItem(addon, sectionPayload = {}) {
      const payload = {
        items: [
          {
            id: Number(addon.id),
            quantity: addon.quantity
          }
        ]
      };

      if (addon.properties) {
        payload.items[0].properties = addon.properties;
      }

      if (sectionPayload.sections) {
        payload.sections = sectionPayload.sections;
      }

      if (sectionPayload.sections_url) {
        payload.sections_url = sectionPayload.sections_url;
      }

      const config = fetchConfig();
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(payload);

      return fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.status) {
            const error = new Error(responseJson.description || responseJson.message || window.cartStrings.error);
            error.response = responseJson;
            throw error;
          }
          return responseJson;
        });
    }
  });
}
